'use client';

import { ReactNode } from 'react';
import { NextIntlClientProvider } from "next-intl";
import { SessionProvider } from "next-auth/react";
import { CartProvider } from "@/components/cart";
import TopNav from "@/components/header/topNav";
import NavBar from "@/components/header/NavBar";
import ScrollToTopButton from '@/components/home-page/TopButton';
import Footer from '@/components/footer/footer';
import End from '@/components/footer/end';
import YandexMetrika from "@/components/YandexMetrika";

interface ClientLayoutProps {
  locale: string;
  messages: any;
  children: ReactNode;
}

export default function ClientLayout({ locale, messages, children }: ClientLayoutProps) {
  return (
    <NextIntlClientProvider locale={locale} messages={messages}>
      <SessionProvider basePath="/api/auth">
        <CartProvider>
          <TopNav />
          <NavBar />
          {children}
          <YandexMetrika />
          <Footer />
          <End />
          <ScrollToTopButton />
        </CartProvider>
      </SessionProvider>
    </NextIntlClientProvider>
  );
}